import { render, staticRenderFns } from "./CohortMembers.vue?vue&type=template&id=a9324cb6&scoped=true"
import script from "./CohortMembers.vue?vue&type=script&lang=js"
export * from "./CohortMembers.vue?vue&type=script&lang=js"
import style0 from "./CohortMembers.vue?vue&type=style&index=0&id=a9324cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9324cb6",
  null
  
)

export default component.exports